export default "__VITE_ASSET__Bkzs_uQM__"